const cardItems = [
  {
    title: '本月必看：高分悬疑剧单',
    desc: '精选10部豆瓣8分以上悬疑神作，烧脑剧情全程高能，每一部都值得二刷回味。',
    img: 'https://readdy.ai/api/search-image?query=Mystery%20detective%20board%20with%20dark%20ambient%20lighting%2C%20magnifying%20glass%20and%20case%20files%20scattered%20on%20wooden%20desk%2C%20film%20noir%20atmosphere%2C%20warm%20desk%20lamp%20glow%2C%20cinematic%20mood%2C%20professional%20photography%2C%20deep%20shadows%2C%20minimalist%20composition&width=800&height=500&seq=douhua-cards-01&orientation=landscape',
    tag: '编辑精选',
  },
  {
    title: '暑期档古装剧追剧指南',
    desc: '《锦绣浮生》《长相思》《庆余年》等热门古装大剧一次收齐，陪你度过悠长夏日。',
    img: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ink%20painting%20style%20landscape%20with%20ancient%20palace%20silhouette%2C%20misty%20mountains%2C%20soft%20warm%20sunset%20colors%2C%20elegant%20artistic%20composition%2C%20cultural%20aesthetic%2C%20minimalist%20design%2C%20calm%20atmosphere&width=800&height=500&seq=douhua-cards-02&orientation=landscape',
    tag: '追剧指南',
  },
  {
    title: '国产动漫崛起：年度精选',
    desc: '《灵笼》《凡人修仙传》《斗破苍穹》等国漫佳作，画面精细剧情扎实，国漫新力量不容错过。',
    img: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20animation%20art%20style%20composition%2C%20fantasy%20landscape%20with%20floating%20islands%20and%20ancient%20architecture%2C%20vibrant%20colors%2C%20epic%20scale%2C%20digital%20art%20illustration%2C%20cinematic%20lighting%2C%20dreamlike%20atmosphere&width=800&height=500&seq=douhua-cards-03&orientation=landscape',
    tag: '动漫推荐',
  },
  {
    title: '周末电影之夜：喜剧片单',
    desc: '开心麻花全系列、经典港式喜剧、热门都市轻喜剧，轻松解压欢笑不断的最佳选择。',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20home%20movie%20night%20scene%2C%20popcorn%20and%20soft%20blanket%20on%20sofa%2C%20warm%20ambient%20lighting%2C%20television%20glow%2C%20comfortable%20living%20room%20atmosphere%2C%20relaxed%20evening%20vibe%2C%20minimalist%20interior%2C%20soft%20focus%20photography&width=800&height=500&seq=douhua-cards-04&orientation=landscape',
    tag: '周末推荐',
  },
  {
    title: '纪录片爱好者必收清单',
    desc: 'BBC《地球脉动》、国家地理系列、国产高分纪录片全集，足不出户看遍世界精彩。',
    img: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20landscape%20photography%20of%20natural%20wonders%2C%20snow%20capped%20mountains%20reflecting%20in%20crystal%20lake%2C%20golden%20hour%20light%2C%20documentary%20style%20composition%2C%20breathtaking%20nature%20scene%2C%20professional%20wildlife%20photography%20quality&width=800&height=500&seq=douhua-cards-05&orientation=landscape',
    tag: '纪录片',
  },
  {
    title: '经典重温：港片黄金年代',
    desc: '周星驰、成龙、王家卫等港片经典作品回顾，那些年我们追过的港片一次看够。',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%20Hong%20Kong%20cityscape%20with%20vintage%20neon%20signs%2C%20warm%20amber%20street%20lights%2C%20rain%20soaked%20streets%2C%20retro%201990s%20aesthetic%2C%20cinematic%20atmosphere%2C%20film%20photography%20style%2C%20nostalgic%20mood&width=800&height=500&seq=douhua-cards-06&orientation=landscape',
    tag: '经典回顾',
  },
  {
    title: '热门综艺：笑点密集合集',
    desc: '《喜剧大会》《脱口秀》等热门综艺最新期，全程高能笑点不断，解压神器在线观看。',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20stage%20performance%20with%20warm%20spotlights%2C%20entertaining%20variety%20show%20atmosphere%2C%20vibrant%20stage%20design%2C%20energetic%20crowd%20silhouettes%2C%20show%20business%20aesthetic%2C%20bright%20cheerful%20lighting%2C%20professional%20event%20photography&width=800&height=500&seq=douhua-cards-07&orientation=landscape',
    tag: '综艺推荐',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 mb-2">
          精选合集
        </h2>
        <p className="text-sm text-foreground-500 mb-8 font-body">编辑精心策划的影视片单，总有一款适合你</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cardItems.slice(0, 6).map((item) => (
            <div
              key={item.title}
              className="rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer group"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded-md bg-background-50/90 text-foreground-700 text-xs font-semibold font-label">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-1.5">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed font-body line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
          <div className="rounded-xl overflow-hidden bg-gradient-to-br from-primary-100 via-primary-50 to-background-100 border border-primary-200/50 flex flex-col items-center justify-center p-6 text-center cursor-pointer hover:border-primary-300 transition-all">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500 text-background-50 mb-3">
              <i className="ri-add-line text-xl"></i>
            </div>
            <h3 className="text-sm font-heading font-semibold text-primary-700 mb-1">{cardItems[6].title}</h3>
            <p className="text-xs text-foreground-500 font-body line-clamp-2">{cardItems[6].desc}</p>
          </div>
        </div>
      </div>
    </section>
  );
}